// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_92-0";
export var actionModalContentContainer = "_92-1";
export var createTagButton = "_92-2";
export var footerContainer = "_92-7";
export var fullWidthDivider = "_92-3";
export var hasCreateTagButton = "_92-4";
export var noCreateTagButton = "_92-5";
export var tagsContainer = "_92-6";
export var tagsModalContentContainer = "_92-8";